import React from 'react';

export default function Admin() {
  return (
    <div className="max-w-[900px] mx-auto px-[clamp(16px,5vw,40px)] py-8">
      <h1 className="text-2xl font-extrabold mb-3">Admin</h1>
      <p className="text-slate-600">Admin-only tools will go here.</p>
    </div>
  );
}
